import { ReactNode } from 'react';

export interface EmojiProps {
  emoji: ReactNode;
  ariaLabel: string;
}

export function Emoji({ emoji, ariaLabel }: EmojiProps) {
  return (
    <span role="img" aria-label={ariaLabel}>
      {emoji}
    </span>
  );
}
